import {NgModule} from '@angular/core';
import {OptInQuestionComponent} from "./opt-in-question.component";
import {ButtonModule, CheckboxModule, InputsModule} from "@xref/xref-lib";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {
    HowToPersonaliseContentModalModule
} from "../how-to-personalise-content-modal/how-to-personalise-content-modal.module";

@NgModule({
    declarations: [OptInQuestionComponent],
    imports: [CheckboxModule, InputsModule, ButtonModule, FormsModule, CommonModule, HowToPersonaliseContentModalModule],
    exports: [OptInQuestionComponent]
})

export class OptInQuestionModule {
}